module.exports = __webpack_public_path__ + "img/chevron-right.199724fd.svg";